import {
  NewUserWrapper,
  NoticeWrapper,
  ReservationWrapper,
  TodayTournamentWrapper,
  Wrapper,
} from "./style";
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  BarElement,
  Chart as ChartJS,
  BarController,
} from "chart.js";
import { Chart, Line } from "react-chartjs-2";
import { useRecoilValue } from "recoil";
import { pubState } from "../../recoil/pub.atom";
import {
  DashboardReservationDto,
  DashboardSummaryDto,
  getDashboard,
} from "../../api/dashboard";
import { useEffect, useState } from "react";
import { TimerDto, TournamentResponse } from "../../api/tournament";
import { StructuresResponse } from "../tournament/hook/useEditTournament";
import { calculateHomeLevel } from "../timer-controller/hooks/timer";
import {
  DailySellerMemberResponse,
  getMemberMainDashboard,
} from "../../api/member";
import { Title } from "../../styles/page";
import { RankingBoardSetting } from "./compoment/ranking-board-setting";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  BarController,
  Tooltip,
  Legend,
);
const Home = () => {
  const customImage = new Image();
  const pub = useRecoilValue(pubState);
  customImage.src = "/image-web/dashboard/chart/pointer.svg";
  const [reservationChartData, setReservationChartData] = useState<number[]>(
    [],
  );
  const [summary, setSummary] = useState<DashboardSummaryDto | null>(null);
  const [isRankingBoardSettingOpen, setIsRankingBoardSettingOpen] =
    useState(false);
  const getLevel = (
    timerDto: TimerDto,
    levels: StructuresResponse[],
  ): number => {
    const now = new Date();
    const updatedAt = new Date(timerDto.updatedAt);
    const elapsedTimeMs =
      now.getTime() - updatedAt.getTime() + timerDto.playTime;

    const { currentLevel } = calculateHomeLevel(elapsedTimeMs, levels);

    if (currentLevel?.level) {
      return currentLevel?.level;
    } else {
      if (currentLevel?.ord && levels[currentLevel?.ord]) {
        return levels[currentLevel?.ord - 1].level || 0;
      } else {
        return 0;
      }
    }
  };
  const [reservationChartDataPlus20, setReservationChartDataPlus20] = useState<
    number[]
  >([]);
  const [todayTournament, setTodayTournament] = useState<TournamentResponse[]>(
    [],
  );

  const [reservationFilterType, setReservationFilterType] = useState("daily");
  const [isReservationFilterOpen, setIsReservationFilterOpen] = useState(false);
  const [memberData, setMemberData] = useState<DailySellerMemberResponse[]>([]);
  const [memberLabels, setMemberLabels] = useState<string[]>([]);
  const [memberGraphDate, setMemberGraphDate] = useState<string[]>([]);
  const [monthlyRegister, setMonthlyRegister] = useState<number>(0);
  const [weeklyRegister, setWeeklyRegister] = useState<number>(0);

  const filter = ["daily", "weekly", "monthly"];

  const [dateList, setDateList] = useState<string[]>([]);
  const [todayDifference, setTodayDifference] = useState<number>(0);
  function convertToNumberArray(
    reservations: DashboardReservationDto[],
  ): number[] {
    return reservations.map((reservation) => reservation.count);
  }
  function convertToDateArray(
    reservations: DashboardReservationDto[],
  ): string[] {
    if (reservationFilterType === "daily") {
      return reservations.map((reservation) => getWeek(reservation.dayOfWeek));
    }
    return reservations.map((reservation) => reservation.dayOfWeek);
  }
  function convertToNumberPlus20Array(
    reservations: DashboardReservationDto[],
  ): number[] {
    return reservations.map((reservation) => reservation.count * 1.1);
  }
  const getDashboardByCafeId = async () => {
    if (!pub) return;
    const res = await getDashboard(pub?.id, reservationFilterType);
    const numberArray = convertToNumberArray(res.reservation);
    const numberArrayPlus20 = convertToNumberPlus20Array(res.reservation);
    setReservationChartData(numberArray);
    setReservationChartDataPlus20(numberArrayPlus20);
    setTodayTournament(res.tournament);
    setDateList(convertToDateArray(res.reservation));
    setSummary(res.summary);
    setTodayDifference(res.todayDifference);
  };

  const getMemberDashboard = async () => {
    if (!pub) return;
    const res = await getMemberMainDashboard(pub.id);
    setMemberData(res.daily);
    setWeeklyRegister(() => {
      return res.weeklyCount;
    });
    setMonthlyRegister(() => {
      return res.monthlyCount;
    });
  };

  useEffect(() => {
    getMemberDashboard();
  }, [pub]);

  useEffect(() => {
    setMemberLabels(() => {
      let newLabels = memberData.map((item) => getWeek(item.day));
      return newLabels;
    });

    setMemberGraphDate(() => {
      let newData = memberData.map((item) =>
        item.registerCount.toLocaleString(),
      );
      return newData;
    });
  }, [memberData]);

  useEffect(() => {
    getDashboardByCafeId();
  }, [reservationFilterType]);

  const getWeek = (value: string) => {
    const [year, month, day] = value.split("-");
    const date = new Date(+year, +month - 1, +day);

    const dayOfWeek = date.getDay();

    const days = ["일", "월", "화", "수", "목", "금", "토"];

    return days[dayOfWeek];
  };

  const data = {
    labels: memberLabels,
    datasets: [
      {
        data: memberGraphDate,
        fill: false,
        borderColor: "#7459D9",
        tension: 0.3,
        pointRadius: 0,
        pointStyle: customImage,
        hitRadius: 40,
        datalabels: {
          display: false,
        },
      },
    ],
  };
  const backgroundColors = [
    "#E9ECF1",
    "#E9ECF1",
    "#E9ECF1",
    "#E9ECF1",
    "#E9ECF1",
    "#E9ECF1",
    "#6436E7",
  ];

  const data2 = {
    labels: dateList,
    datasets: [
      {
        type: "line" as const,
        label: "First dataset",
        data: reservationChartData,
        fill: false,
        borderColor: "#000",
        pointRadius: 4,
        hitRadius: 40,
        datalabels: {
          display: false,
        },
      },
      {
        type: "bar" as const,
        label: "Dataset 2",
        data: reservationChartDataPlus20,
        backgroundColor: backgroundColors,
        fill: false,
        borderWidth: 1,
        borderRadius: { topLeft: 10, topRight: 10 },
        barThickness: 19,
        datalabels: {
          display: false,
        },
      },
    ],
  };
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        external: function (context: any) {
          let tooltipEl = document.getElementById("chartjs-tooltip");
          let line = document.getElementById("line");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.backgroundSize = "cover";
            tooltipEl.style.borderRadius = "6px";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.color = "#000";
            tooltipEl.style.padding = "20px";
            tooltipEl.style.fontSize = "12px";
            tooltipEl.style.transition = "all .1s ease";
            tooltipEl.style.width = "180px";
            tooltipEl.style.height = "110px";
            tooltipEl.style.display = "flex";
            tooltipEl.style.flexDirection = "column";
            document.body.appendChild(tooltipEl);
          }

          if (!line) {
            line = document.createElement("div");
            line.id = "line";
            line.style.width = "0";
            line.style.borderRight = "2px dashed #422F8ADE";
            line.style.position = "absolute";
            document.body.appendChild(line);
          }

          const chart = context.chart;
          const tooltipDataPoint = context.tooltip.dataPoints[0];
          const position = context.chart.canvas.getBoundingClientRect();
          const x =
            position.left +
            window.pageXOffset +
            context.tooltip.caretX -
            180 / 2 +
            -20;
          const y =
            position.top +
            window.pageYOffset +
            context.tooltip.caretY -
            tooltipEl.offsetHeight;
          let height = chart.scales["x"].top - tooltipDataPoint.element.y - 10;

          if (y + 260 > 502) height = 0;

          line.style.height = height + "px";
          line.style.left = x + 108 + "px";
          line.style.top = y + 160 + "px";
          line.style.opacity = "1";

          if (context.tooltip.opacity === 0) {
            tooltipEl.style.opacity = "0";
            line.style.opacity = "0";
            return;
          }

          tooltipEl.style.backgroundImage =
            "url('/image-web/dashboard/chart/tooltip.svg')";
          tooltipEl.style.filter =
            "drop-shadow(0px 8px 16px rgba(50, 50, 71, 0.06)) drop-shadow(0px 8px 8px rgba(50, 50, 71, 0.08))";

          tooltipEl.style.opacity = "1";
          tooltipEl.style.left = x + "px";
          tooltipEl.style.top = y + "px";
          const dataPointValue = context.tooltip.dataPoints[0].raw;
          tooltipEl.innerHTML = `
            <div style="margin-top: 5px; margin-left: 10px; margin-bottom: 5px;color: rgba(60, 60, 67, 0.60);font-feature-settings: 'liga' off, 'clig' off;font-family: Pretendard;font-size: 12px;font-style: normal;font-weight: 400;line-height: 20px;">신규 회원이 늘어나고 있어요!</div>
            <div style="margin-left: 10px;color: var(--Light-Black, #11263C);font-family: Pretendard;font-size: 22px;font-style: normal;font-weight: 700;line-height: 28px;">${dataPointValue.toLocaleString()}</div>
          `;
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          display: true,
          font: {
            size: 12.97,
            color: "#A2A3A5",
            weight: 400,
            family: "Pretendard",
          },
        },
      },
      y: {
        afterDataLimits: (scale: any) => {
          scale.max = scale.max * 1.2;
        },
        grid: {
          display: true,
          drawBorder: false,
        },
        ticks: {
          display: true,
          maxTicksLimit: 4,
          font: {
            size: 12.97,
            color: "#A2A3A5",
            weight: 400,
            family: "Pretendard",
          },
        },
        border: {
          width: 0,
        },
      },
    },
  };

  const options2 = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        external: function (context: any) {
          const dataPoint = context.tooltip.dataPoints[0];
          const datasetType =
            context.chart.config.data.datasets[dataPoint.datasetIndex].type;

          if (datasetType === "bar") {
            return;
          }
          let tooltipEl = document.getElementById("chartjs-tooltip");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.backgroundSize = "cover";
            tooltipEl.style.borderRadius = "6px";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.color = "#000";
            tooltipEl.style.padding = "20px";
            tooltipEl.style.fontSize = "12px";
            tooltipEl.style.transition = "all .1s ease";
            tooltipEl.style.width = "180px";
            tooltipEl.style.height = "110px";
            tooltipEl.style.display = "flex";
            tooltipEl.style.flexDirection = "column";
            document.body.appendChild(tooltipEl);
          }

          if (context.tooltip.opacity === 0) {
            tooltipEl.style.opacity = "0";
            return;
          }

          tooltipEl.style.backgroundImage =
            "url('/image-web/dashboard/chart/tooltip.svg')";
          tooltipEl.style.filter =
            "drop-shadow(0px 8px 16px rgba(50, 50, 71, 0.06)) drop-shadow(0px 8px 8px rgba(50, 50, 71, 0.08))";
          const position = context.chart.canvas.getBoundingClientRect();
          tooltipEl.style.opacity = "1";
          tooltipEl.style.left =
            position.left +
            window.pageXOffset +
            context.tooltip.caretX -
            180 / 2 +
            -20 +
            "px";
          tooltipEl.style.top =
            position.top +
            window.pageYOffset +
            context.tooltip.caretY -
            tooltipEl.offsetHeight +
            "px";
          const dataPointValue = context.tooltip.dataPoints[0].raw;
          tooltipEl.innerHTML = `
            <div style="margin-top: 5px; margin-left: 10px; margin-bottom: 5px;color: rgba(60, 60, 67, 0.60);font-feature-settings: 'liga' off, 'clig' off;font-family: Pretendard;font-size: 12px;font-style: normal;font-weight: 400;line-height: 20px;">이 날의 예약 현황</div>
            <div style="margin-left: 10px;color: var(--Light-Black, #11263C);font-family: Pretendard;font-size: 22px;font-style: normal;font-weight: 700;line-height: 28px;">${dataPointValue.toLocaleString()}</div>
          `;
        },
      },
    },
    layout: {
      padding: {
        left: 10,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          display: true,
          font: {
            size: 12.66,
            color: "#121212",
            weight: 400,
            family: "Pretendard",
          },
        },
      },
      y: {
        afterDataLimits: (scale: any) => {
          scale.max = scale.max * 1.2;
        },
        border: {
          width: 0,
        },
        grid: {
          display: true,
          drawBorder: false,
        },
        ticks: {
          display: true,
          font: {
            size: 12.3,
            color: "#797979",
            weight: 600,
            family: "Pretendard",
          },
          maxTicksLimit: 4,
          callback: (value: any) => value.toLocaleString() + "명",
        },
      },
    },
  };
  return (
    <Wrapper>
      <div className="top-title">
        {pub?.cafeName} 대시보드
        <div className="ranking-board-button-wrapper">
          <img
            src="/image-web/tier/setting.svg"
            alt="ranking-board"
            onClick={() => {
              setIsRankingBoardSettingOpen(!isRankingBoardSettingOpen);
            }}
          />
          <div
            className="ranking-board-button"
            onClick={() => {
              window.open("/ranking-board", "_blank");
            }}
          >
            랭킹보드 열기
          </div>
        </div>
      </div>
      <div className="top-wrapper">
        <NewUserWrapper>
          <div className="wrapper">
            <div className="left-box">
              <div className="title">신규 회원 현황</div>
              <div className="box">
                <Title size={20} weight={500}>
                  이번주
                </Title>
                <div className="value">{weeklyRegister}+</div>
              </div>
              <div className="box">
                <Title size={20} weight={500}>
                  이번달
                </Title>
                <div className="value">{monthlyRegister}+</div>
              </div>
            </div>
            <div className="right-box">
              <Line data={data} options={options} />
            </div>
          </div>
        </NewUserWrapper>
        <NoticeWrapper>
          <div className="wrapper">
            <Title size={25} weight={700}>
              공지사항
            </Title>
            <div className="no-content">등록된 공지사항이 없습니다.</div>
            <div className="button">더 보러 가기</div>
          </div>
          <div className="overlay">COMING SOON...</div>
        </NoticeWrapper>
      </div>
      <div className="bottom-wrapper">
        <TodayTournamentWrapper>
          <div className="wrapper">
            <div className="title">오늘의 토너먼트</div>
            <div className="list-wrapper">
              {todayTournament.length === 0 && (
                <div className="no-tournament">등록된 토너먼트가 없습니다.</div>
              )}
              {todayTournament.map((item, index) => (
                <div className="item-wrapper">
                  <div className="title">{item.title}</div>
                  <div className="button-wrapper">
                    <div
                      className={`button ${
                        item.isEnd
                          ? "end"
                          : item.timerDto
                            ? getLevel(item.timerDto, item.structure) !== 0
                              ? +getLevel(item.timerDto, item.structure) <=
                                item.registerDeadlineLevel
                                ? "reservation"
                                : "playing"
                              : "playing"
                            : "reservation"
                      }`}
                    >
                      {item.isEnd
                        ? "종료"
                        : item.timerDto
                          ? getLevel(item.timerDto, item.structure) !== 0
                            ? +getLevel(item.timerDto, item.structure) <=
                              item.registerDeadlineLevel
                              ? "예약중"
                              : "진행중"
                            : "진행중"
                          : "예약중"}
                    </div>
                    <div
                      className={`button ${
                        item.isEnd
                          ? "end"
                          : item.timerDto
                            ? getLevel(item.timerDto, item.structure) !== 0
                              ? +getLevel(item.timerDto, item.structure) <=
                                item.registerDeadlineLevel
                                ? "reservation"
                                : "playing"
                              : "playing"
                            : "reservation"
                      }`}
                    >
                      엔트리{" "}
                      {item.reBuyInUserCount +
                        item.entryUserCount +
                        item.adOnUserCount}
                      회
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </TodayTournamentWrapper>
        <ReservationWrapper>
          <div className="wrapper">
            <div className="header">
              <Title size={25} weight={700}>
                예약 현황
              </Title>
              <div
                className="drop-box-wrapper"
                onClick={() => {
                  setIsReservationFilterOpen(!isReservationFilterOpen);
                }}
              >
                <div className="value">
                  {reservationFilterType === "daily"
                    ? "일별 통계"
                    : reservationFilterType === "weekly"
                      ? "주간 통계"
                      : "월간 통계"}
                </div>
                <img src="/image-web/dashboard/reservation/drop.svg" />
                {isReservationFilterOpen && (
                  <div className="drop-box">
                    {filter.map((type, index) => (
                      <div
                        className={`item ${
                          reservationFilterType === type && "active"
                        }`}
                        onClick={() => {
                          setReservationFilterType(type);
                        }}
                      >
                        {type === "daily"
                          ? "일별 통계"
                          : type === "weekly"
                            ? "주간 통계"
                            : "월간 통계"}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="info-wrapper">
              <div className="yesterday-wrapper">
                <div className="left">
                  <img
                    src={`${
                      todayDifference > 0
                        ? `/image-web/dashboard/reservation/smile.svg`
                        : todayDifference < 0
                          ? `/image-web/dashboard/reservation/un-smile.svg`
                          : "/image-web/dashboard/reservation/smile.svg"
                    }`}
                  />
                  <div className="description">
                    {`${
                      todayDifference > 0
                        ? `어제보다`
                        : todayDifference < 0
                          ? `어제보다`
                          : "어제와"
                    }`}
                    <br />
                    {`${
                      todayDifference > 0
                        ? `많이 방문했어요!`
                        : todayDifference < 0
                          ? `덜 방문했어요!`
                          : "똑같이 방문했어요!"
                    }`}
                  </div>
                </div>
                <div className="right">{`${
                  todayDifference > 0
                    ? `+ ${todayDifference}명`
                    : todayDifference < 0
                      ? `- ${Math.abs(todayDifference)}명`
                      : "+ 0명"
                }`}</div>
              </div>
              <div className="data-wrapper">
                <div className="item">
                  <div className="title">오늘 예약</div>
                  <div className="value">
                    {summary
                      ? summary.todayReservationCount.toLocaleString()
                      : 0}
                    명
                  </div>
                </div>
                <div className="item">
                  <div className="title">이번 주 예약</div>
                  <div className="value">
                    {summary
                      ? summary.weekReservationCount.toLocaleString()
                      : 0}
                    명
                  </div>
                </div>
                <div className="item">
                  <div className="title">이번 달 예약</div>
                  <div className="value">
                    {summary
                      ? summary.monthReservationCount.toLocaleString()
                      : 0}
                    명
                  </div>
                </div>
              </div>
            </div>
            <div className="chart">
              <Chart type="bar" data={data2} options={options2} />
            </div>
          </div>
        </ReservationWrapper>
      </div>
      {isRankingBoardSettingOpen && (
        <RankingBoardSetting
          setIsRankingBoardSettingOpen={setIsRankingBoardSettingOpen}
        />
      )}
    </Wrapper>
  );
};
export default Home;
